<p-panel
  [showHeader]="false"
  styleClass="panel-shadow mt-3 no-padding-panel"
  [style]="{ 'max-width': '1650px' }"
  #panel
>
  <div class="ui-g job-details-container">
    <div class="ui-g-12">
      <div *ngIf="selectedTask" class="flex flex-wrap">
        <div *ngIf="tasks" class="style2023 listbox-wrapper">
          <!--
          -->
          <p-listbox
            styleClass="no-border-listbox mobile-listbox-block extended-listbox-width"
            [ngModel]="selectedTask"
            (ngModelChange)="changeSelectedTask($event.id)"
            [options]="taskSequenceEditMode ? tasksCopyForSequenceEdit : tasks"
            dataKey="id"
          >
            <ng-template let-task let-i="index" pTemplate="item">
              <div class="task-sequence-count-container">
                <div class="task-sequence-count" *ngIf="task.value.taskSequence != null">
                  Task {{ i + 1 }}
                </div>
                <div class="task-sequence-move-buttons" *ngIf="taskSequenceEditMode">
                  <button
                    class="sort-btn"
                    pButton
                    icon="fa fa-angle-up"
                    [disabled]="i == 0"
                    (click)="moveTaskSequenceUp(task)"
                  ></button>
                  <button
                    class="sort-btn"
                    pButton
                    icon="fa fa-angle-down"
                    [disabled]="i + 1 == tasks?.length"
                    (click)="moveTaskSequenceDown(task)"
                  ></button>
                </div>
                <div
                  class="chip"
                  *ngIf="
                    task.value.taskStatusName && organisationTypeId == 1 && !taskSequenceEditMode
                  "
                >
                  {{ task.value.taskStatusName }}
                </div>
              </div>
              <div class="registration">
                {{ task.value.vehicle.regNumber }}
              </div>
              <div
                *ngIf="selectedTask.requiresDelayFailureReason && organisationTypeId == 1"
                style="text-align: left; font-size: smaller"
                class="text-danger"
              >
                Requires Delay/Failure
              </div>
              <div style="text-align: left; font-size: smaller">
                {{ task.value.vehicle.make }} {{ task.value.vehicle.model }}
              </div>
              <div style="text-align: left; font-size: smaller">
                {{ task.value.vehicle.kerbWeight }} kg. {{ task.value.vehicle.color }}
              </div>
              <div class="status" *ngIf="organisationTypeId == 1">
                {{ task.value.regStatusName }}
              </div>
            </ng-template>
          </p-listbox>
          <div
            *ngIf="tasks?.length > 1"
            class="task-sequence-indicator"
            [ngClass]="
              taskSequencingEnabled
                ? 'task-sequence-indicator-enabled'
                : 'task-sequence-indicator-disabled'
            "
          >
            <ng-container *ngIf="taskSequencingEnabled">
              <i
                class="fa fa-exclamation-triangle"
                aria-hidden="true"
                pTooltip="Tasks in this job must be completed in the specific sequence labeled."
              ></i>
              <div>Mandatory Task Sequence</div>
            </ng-container>

            <ng-container *ngIf="!taskSequencingEnabled">
              <i
                class="fa fa-info-circle"
                aria-hidden="true"
                pTooltip="Tasks in this job can be completed in any sequence."
              ></i>
              <div>Flexible Task Sequence</div>
            </ng-container>
          </div>
          <div
            *ngIf="
              tasks?.length > 1 &&
              (organisationTypeId == OrganisationTypeEnum.Engineius ||
                organisationTypeId == OrganisationTypeEnum.Customer ||
                organisationTypeId == 0)
            "
          >
            <div class="task-sequence-enable-options">
              <p-inputSwitch
                [disabled]="taskSequenceEditMode || order.jobStatusId != 5"
                [(ngModel)]="taskSequencingEnabled"
                (onChange)="handleTaskSequenceToggle($event)"
              ></p-inputSwitch>
              <span class="toggle-label">Use specific task sequence</span>
            </div>
            <div class="task-sequence-edit" *ngIf="order.jobStatusId == 5">
              <button
                type="button"
                pButton
                (click)="editTaskSequence()"
                label="Edit Task Sequence"
                class="ui-btn-secondary sequence-edit-btn-style"
                *ngIf="!taskSequenceEditMode && taskSequencingEnabled"
              ></button>
              <button
                type="button"
                pButton
                (click)="saveTaskSequence()"
                label="Save"
                class="ui-btn-secondary sequence-edit-btn-style"
                *ngIf="taskSequenceEditMode"
              ></button>
              <button
                type="button"
                pButton
                (click)="cancelTaskSequenceEdit()"
                label="Cancel"
                class="ui-btn-secondary sequence-edit-cancel-btn-style"
                *ngIf="taskSequenceEditMode"
              ></button>
            </div>
          </div>
        </div>

        <div
          class="flex-grow-1"
          style="padding: 20px; box-shadow: -5px 0 5px -5px rgba(0, 0, 0, 0.3)"
        >
          <div class="flex grid-gap-15 flex-wrap justify-content-start">
            <div class="flex-grow-1" style="flex-basis: 200px; max-width: 750px">
              <div style="margin-right: 5px">
                <div style="margin-bottom: 15px">
                  <div class="flex justify-content-between align-items-center">
                    <div class="vehicle-reg">{{ selectedTask.vehicle.regNumber }}</div>
                    <span *ngIf="selectedTask">
                      <div
                        *ngFor="let category of selectedTask.checklistSubCategories"
                        style="margin-top: 7px; margin-right: 7px"
                      >
                        <checklist-category-item [subCategory]="category"></checklist-category-item>
                      </div>
                    </span>
                  </div>

                  <div class="vehicle-info">
                    {{ selectedTask.vehicle.make }} {{ selectedTask.vehicle.model }}
                  </div>
                  <div class="vehicle-info">
                    <span *ngFor="let field of secondaryVehicleInfo; let i = index">
                      {{ field }}<span *ngIf="i != secondaryVehicleInfo.length - 1"> &bull; </span>
                    </span>
                  </div>

                  <div class="flex align-items-baseline">
                    <div class="">
                      <span class="route-info-value">{{ routeInfo?.distanceMiles }} miles</span>
                      <span class="est">EST.</span>
                      <span class="est-div">/</span>
                    </div>

                    <div class="">
                      <span class="route-info-value">{{ routeInfo?.time }}</span>
                      <span class="est">EST.</span>
                    </div>

                    <div class="">
                      <span class="movement-type">{{ selectedTask.taskTypeName }}</span>
                    </div>
                  </div>
                  <div *ngIf="selectedTask.isRescheduled" class="flex mt-2">
                    <span class="text-warning flex-1">Rescheduled</span>
                    <!--                        <div style="width: 150px;">-->
                    <!--                            <div class="opacity-50">Original</div>-->
                    <!--                            <div class="font-bold">Current</div>-->
                    <!--                        </div>-->
                  </div>
                </div>

                <job-screen-task-times
                  [orgTypeId]="organisationTypeId"
                  [taskId]="selectedTask.id"
                  [hideTaskSchedule]="hideTaskSchedule"
                >
                </job-screen-task-times>
              </div>
            </div>

            <div
              class="flex-grow-1"
              style="max-width: 640px; flex-basis: 200px"
              *ngIf="interactiveMap"
            >
              <div>
                <div style="border-radius: 10px; overflow: hidden; margin-bottom: 7px">
                  <map-control
                    [destination]="selectedTask.dropoffLocation"
                    [liveTask]="selectedTask"
                    [origin]="selectedTask.pickupLocation"
                    [customStyle]="{ height: '398px', width: '100%' }"
                    [pauses]="selectedTask.pauses"
                    [readOnly]="true"
                    [alphaIcons]="true"
                    *ngIf="selectedTask"
                    [tasks]="[selectedTask]"
                  ></map-control>
                </div>
              </div>
            </div>
            <div *ngIf="!interactiveMap" (click)="interactiveMap = true">
              <!--              <img [src]="staticMapSrc" class="map-image" style="border-radius: 10px" />-->
              <task-static-map
                [taskIds]="[selectedTaskId]"
                [includePauses]="true"
                [includeTracking]="false"
                [width]="mapWidth"
                [height]="398"
                *ngIf="selectedTaskId"
              ></task-static-map>
            </div>
          </div>

          <div class="flex-initial mt-4 mb-4">
            <job-screen-supplier-schedule
              [taskId]="selectedTask?.id"
              [jobId]="order.jobId"
            ></job-screen-supplier-schedule>
          </div>

          <div
            style="
              display: grid;
              grid-gap: 10px;
              grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
            "
          >
            <div class="flex-grow-1 pdf-split-button" *ngIf="showOrderTrack">
              <p-splitButton
                (onClick)="downloadTrack(false)"
                [disabled]="pdfDownloading"
                [model]="pdfLinkData"
                icon="{{ getPDFIcon() }}"
                label="Download PDF"
                styleClass="pdf-button ui-widget ui-state-default ui-corner-all ui-button-secondary btn-block"
              >
              </p-splitButton>
            </div>

            <div class="flex-grow-1" *ngIf="showOrderTrack && selectedTask.workflowUrl">
              <p-splitButton
                (onClick)="visitURL(selectedTask.workflowUrl)"
                [label]="'Workflow ' + selectedTask.vehicle?.regNumber"
                [model]="workFlows"
                icon="fa fa-external-link"
                styleClass="pdf-button ui-widget ui-state-default ui-corner-all ui-button-secondary btn-block"
              >
              </p-splitButton>
            </div>

            <div class="flex-grow-1" *ngIf="showOrderTrack">
              <button
                (click)="showTrackURL()"
                class="ui-button btn-block ml-0"
                label="Order Track URL"
                pButton
                type="button"
              ></button>
            </div>

            <div class="flex-grow-1" *ngIf="showOrderTrack && organisationTypeId == 1">
              <button
                (click)="recordDelayFailure()"
                class="ui-button btn-block ml-0"
                label="Delay/Failure Notification"
                [ngClass]="selectedTask.requiresDelayFailureReason ? 'highlight' : 'lowlight'"
                pButton
                type="button"
              ></button>
            </div>

            <div
              *ngIf="
                selectedTask &&
                !selectedTask.isCancelled &&
                !selectedTask.isComplete &&
                ((organisationTypeId == 1 && order.jobSupplierId) ||
                  (organisationTypeId == 3 && order.jobSupplierId == organisationId))
              "
              class="flex-grow-1"
            >
              <button
                pButton
                (click)="onEditSupplierScheduleClick()"
                label="Edit Task Schedule"
                class="ui-button btn-block ml-0"
                [title]="
                  organisationTypeId == 3 && !selectedTask.canBeRescheduled
                    ? 'Task too close to collection date'
                    : ''
                "
                [disabled]="organisationTypeId == 3 && !selectedTask.canBeRescheduled"
              ></button>
            </div>

            <div class="flex-grow-1" *ngIf="selectedTask && organisationTypeId == 1">
              <button
                pButton
                (click)="editLocations(selectedTask.id)"
                label="Edit Locations"
                class="ui-button btn-block ml-0"
                [disabled]="commonService.isJobStatusCompleted(order.jobStatusId) || !selectedTask"
              ></button>
            </div>

            <div class="flex-grow-1" *ngIf="selectedTask && organisationTypeId == 1">
              <button
                pButton
                (click)="editVehicleVisible = true"
                label="Edit Vehicle"
                class="ui-button btn-block ml-0"
                [disabled]="!selectedTask"
              ></button>
            </div>

            <div class="flex-grow-1" *ngIf="organisationTypeId == 3">
              <button
                pButton
                (click)="goToSimilarJobs()"
                label="Find Similar Jobs"
                class="ui-button btn-block ml-0"
                [disabled]="commonService.isJobStatusCompleted(order.jobStatusId)"
              ></button>
            </div>

            <div *ngIf="organisationTypeId == 1" class="flex-grow-1">
              <button
                pButton
                pTooltip="To be used when a CUSTOMER has requested a date change"
                (click)="showEditTaskDialog = true"
                label="Edit Task Windows"
                class="ui-button w-100 ml-0"
                [disabled]="order.jobStatusId == jobStatus.Closed"
              ></button>
            </div>

            <div
              *ngIf="
                organisationTypeId == 1 && !commonService.isJobStatusCompleted(order.jobStatusId)
              "
              class="flex-grow-1"
            >
              <button
                pButton
                *ngIf="organisationTypeId == 1"
                [disabled]="order.jobSupplierId != null"
                pTooltip="To be used for an unfulfilled task and we want to display new times to the supplier."
                (click)="rescheduleDialogVisible = true"
                label="Reschedule Task"
                class="ui-button red-btn w-100 ml-0"
              ></button>
              <reschedule-task-dialog
                [(visible)]="rescheduleDialogVisible"
                [orderId]="orderId"
                [selectedTaskId]="selectedTaskId"
              ></reschedule-task-dialog>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-panel>

<p-dialog
  [(visible)]="showCopyTrackUrlDialog"
  [style]="{ width: '650px' }"
  header="Order Track URLs"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-g-12"><h4 style="padding: 0; margin: 0">Order Summary</h4></div>
    <div class="ui-grid-row">
      <div class="ui-g-12 ui-lg-10 ui-md-10" style="padding-top: 10px">
        <a href="{{ SummaryOrderUrl }}" target="_blank"
          ><span style="color: darkblue; font-weight: bold">{{ SummaryOrderUrl }}</span></a
        >
      </div>
      <textarea id="txtUrl0" style="display: none; width: 0; height: 0">{{
        SummaryOrderUrl
      }}</textarea>
    </div>
    <div class="ui-grid-row">
      <button
        (click)="copyUrl(0)"
        class="ui-g-12 btn-to-right"
        icon="fa fa-files-o"
        label="Copy &nbsp; &nbsp;"
        pButton
        style="margin-left: 0"
        type="button"
      ></button>
    </div>

    <div class="ui-grid-row">
      <div class="ui-g-12"></div>
    </div>
    <div class="ui-g-12"><h4 style="padding: 0; margin: 20px 0 0 0">Full Order Details</h4></div>
    <div class="ui-grid-row">
      <div class="ui-g-12 ui-lg-10 ui-md-10" style="padding-top: 10px">
        <a href="{{ FullOrderUrl }}" target="_blank"
          ><span style="color: darkblue; font-weight: bold">{{ FullOrderUrl }}</span></a
        >
      </div>
      <textarea id="txtUrl1" style="display: none; width: 0; height: 0">{{
        FullOrderUrl
      }}</textarea>
    </div>
    <div class="ui-grid-row">
      <button
        (click)="copyUrl(1)"
        class="ui-g-12 btn-to-right"
        icon="fa fa-files-o"
        label="Copy &nbsp; &nbsp;"
        pButton
        style="margin-left: 0"
        type="button"
      ></button>
    </div>

    <div class="ui-grid-row">
      <div class="ui-g-12"></div>
    </div>
    <div class="ui-g-12">
      <h4 style="padding: 0; margin: 20px 0 0 0">Full Order Details (No Condition)</h4>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-12 ui-lg-10 ui-md-10" style="padding-top: 10px">
        <a href="{{ FullOrderUrl }}&hd=true" target="_blank"
          ><span style="color: darkblue; font-weight: bold">{{ FullOrderUrl }}&hd=true</span></a
        >
      </div>
      <textarea id="txtUrl2" style="display: none; width: 0; height: 0"
        >{{ FullOrderUrl }}&hd=true</textarea
      >
    </div>
    <div class="ui-grid-row">
      <button
        (click)="copyUrl(2)"
        class="ui-g-12 btn-to-right"
        icon="fa fa-files-o"
        label="Copy &nbsp; &nbsp;"
        pButton
        style="margin-left: 0"
        type="button"
      ></button>
    </div>

    <div class="ui-grid-row">
      <div class="ui-g-12"></div>
    </div>
    <div class="ui-grid-row" style="padding-top: 5px">
      <div class="ui-g-12" style="text-align: center">
        <label
          *ngIf="showCopyConfirmation"
          style="color: green; font-weight: bold; font-size: small"
          >Link copied to clipboard</label
        >
      </div>
    </div>
    <div class="ui-grid-row" style="float: right; margin-bottom: 10px; padding-top: 10px">
      <button
        (click)="showCopyTrackUrlDialog = false"
        icon="fa ui-icon-close"
        label="Close"
        pButton
        type="button"
      ></button>
    </div>
  </div>
</p-dialog>

<job-screen-delay-failures-dialog
  [(visible)]="delayFailureDialogVisible"
  [taskId]="selectedTaskId"
  (onCreated)="onDelayFailureCreated()"
>
</job-screen-delay-failures-dialog>

<edit-task-windows-dialog
  [(visible)]="showEditTaskDialog"
  [task]="selectedTask"
  (taskUpdated)="onTaskWindowUpdated()"
>
</edit-task-windows-dialog>

<edit-task-schedule-dialog
  *ngIf="selectedTask && order?.jobId"
  referrPage="newJobScreen"
  [(visible)]="editTaskScheduleVisible"
  [taskId]="selectedTask.id"
  [jobId]="order.jobId"
  (scheduleUpdated)="onScheduleUpdated()"
  [taskScheduleSource]="TaskSupplierScheduleSource.EngineiusEdit"
></edit-task-schedule-dialog>

<job-screen-edit-vehicle-dialog
  [(visible)]="editVehicleVisible"
  [taskId]="selectedTask?.id"
  (vehicleUpdated)="onVehicleUpdated()"
>
</job-screen-edit-vehicle-dialog>
